import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="error-boundary" role="alert">
          <h1>Something went wrong.</h1>
          <p>Please refresh the page and try again.</p>
          {import.meta.env.DEV && this.state.error ? (
            <pre>{this.state.error.message}</pre>
          ) : null}
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
